import { render, staticRenderFns } from "./DataDetail.html?vue&type=template&id=49827824&"
import script from "./DataDetail.vue?vue&type=script&lang=js&"
export * from "./DataDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataDetail.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports